module.exports = __webpack_public_path__ + "static/media/difference-between-gatsbyjs-and-nextjs.9f553f26.md";